import type { StyleResolverContext, CssFragment } from './index';

// ============================================================================
// Types
// ============================================================================

export interface FlexProps {
  flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  flexGrow?: number;
  flexShrink?: number;
  flexBasis?: number | string;
}

// ============================================================================
// Resolution helpers
// ============================================================================

/** Returns CSS fragments for flex-direction, flex-wrap, flex-grow, flex-shrink, flex-basis. */
const resolveFlexCss = (props: FlexProps & { flexColumn?: boolean }): CssFragment[] => [
  props.flexColumn ? 'flex-direction: column;' : null,
  props.flexWrap ? `flex-wrap: ${props.flexWrap};` : null,
  props.flexGrow !== undefined ? `flex-grow: ${props.flexGrow};` : null,
  props.flexShrink !== undefined ? `flex-shrink: ${props.flexShrink};` : null,
  props.flexBasis !== undefined
    ? `flex-basis: ${typeof props.flexBasis === 'number' ? `${props.flexBasis}px` : props.flexBasis};`
    : props.flexGrow !== undefined
      ? 'flex-basis: 0;'
      : null,
];

// ============================================================================
// Picker + style resolver
// ============================================================================

const pickFlexProps = <T extends Partial<FlexProps>>(props: T): FlexProps => {
  const { flexWrap, flexGrow, flexShrink, flexBasis } = props;
  return { flexWrap, flexGrow, flexShrink, flexBasis };
};

export const resolveFlexStyleCss = (props: Record<string, unknown>, _theme: StyleResolverContext): CssFragment[] => {
  const flexColumn = Boolean((props as Record<string, unknown>).flexColumn);
  return resolveFlexCss({ ...pickFlexProps(props as Partial<FlexProps>), flexColumn });
};
